export interface LoginRequest {
  email: string
  password: string
}

export interface LoginSuccessResponse {
  id: string
  username: string
  email: string
  avatar: string | null
  last_login_time: string | null
  tenant_id: string
  role: 'admin' | 'user' | null
  language: 'en' | 'fr' | 'es' | null
  groups: { id: string; name: string }[]
}

export interface LoginChallengeResponse {
  error: 'new_password_required'
  session: string
  username: string
}

export type LoginResponse = LoginSuccessResponse | LoginChallengeResponse

export interface PasswordChallengeRequest {
  session: string
  username: string
  new_password: string
}

export interface MeResponse {
  id: string
  email: string
  first_name: string
  last_name: string
  display_name: string
  role: 'admin' | 'user' | null
  language: 'en' | 'fr' | 'es' | null
  avatar: string | null
  tenant: {
    id: string
    name: string
    ext_tenant_id: string
    created_at: string
  }
  groups: { id: string; name: string }[]
}

export interface LogoutResponse {
  message: string
}

// Keep ChallengeResponse for backward compat with ChallengeStorageService
export interface ChallengeResponse {
  challenge: 'NEW_PASSWORD_REQUIRED'
  session: string
  username: string
}

export interface ResetPasswordRequest {
  email: string
  code: string
  new_password: string
}

export interface ResetPasswordResponse {
  message: string
}

export function isLoginChallengeResponse(
  response: LoginResponse
): response is LoginChallengeResponse {
  return 'error' in response && response.error === 'new_password_required'
}
